"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NinetailedGoogleTagmanagerPlugin = void 0;
var NinetailedGoogleTagmanagerPlugin_1 = require("./NinetailedGoogleTagmanagerPlugin");
Object.defineProperty(exports, "NinetailedGoogleTagmanagerPlugin", {
  enumerable: true,
  get: function get() {
    return NinetailedGoogleTagmanagerPlugin_1.NinetailedGoogleTagmanagerPlugin;
  }
});
var NinetailedGoogleTagmanagerPlugin_2 = require("./NinetailedGoogleTagmanagerPlugin");
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return NinetailedGoogleTagmanagerPlugin_2.NinetailedGoogleTagmanagerPlugin;
  }
});